import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    token: localStorage.getItem('Authorization') ? localStorage.getItem('Authorization') : '',
    user: JSON.parse(localStorage.getItem('UserInfo') ? localStorage.getItem('UserInfo') : '{}'),
  },
  getters: {
    token: state => state.token,
    user: state => state.user,
  },
  actions: {
    Logout({ state }) {
      console.log('Logout clear token')
      state.token = '';
      state.user = {};
      localStorage.removeItem('Authorization');
      localStorage.removeItem('UserInfo');
    },
  }
});

export default store



// WEBPACK FOOTER //
// ./src/store/index.js